import { DataSource, HorizontalSpacer, Layout, SearchButton, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutProcessLogViewer extends Layout {
    horizontalspacer1: HorizontalSpacer;
    searchbuttonLog: SearchButton;
    sourceProcessLog: DataSource;
    tableProcessLog: Table;
    textboxDateRun: Textbox;
    textboxDescr: Textbox;
    textboxProcessType: Textbox;
    textboxUserIdSearch: Textbox;
}
